import ShareIcon from "@/common/images/icons/share-red.svg?react";
import "./ShareButton.scss";

interface IShareButtonProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const ShareButton: React.FC<IShareButtonProps> = ({
  onClick
}) => {
  return (
    <button onClick={(event) => onClick(event)} className="ShareButton" aria-label="share button">
      <ShareIcon />
    </button>
  );
};
